import { useState } from "react"
import {
  MuiColorInput,
  MuiColorInputColors,
  MuiColorInputProps,
  MuiColorInputValue,
} from "mui-color-input"
import IconButton from "@mui/material/IconButton/IconButton"
import { ClearIcon } from "@mui/x-date-pickers/icons"
import React from "react"

export type ColorInputProps = Omit<MuiColorInputProps, "value"> & {
  defaultValue?: MuiColorInputProps["value"]
  value?: MuiColorInputProps["value"]
}

const ColorInput = React.forwardRef<HTMLInputElement, ColorInputProps>(
  ({ defaultValue, value, onChange, ...props }, ref) => {
    const [color, setColor] = useState<MuiColorInputValue>(value ?? defaultValue ?? "#ffffff")

    const handleChange = (newValue: string, colors: MuiColorInputColors) => {
      setColor(newValue)
      onChange?.(newValue, colors)
    }

    const handleReset = () => {
      setColor("")
      onChange?.("", { hex: "", hex8: "", hsl: "", hsv: "", rgb: "" })
    }

    return (
      <div style={{ position: "relative" }}>
        <MuiColorInput
          format="hex"
          fallbackValue={defaultValue ?? "#ffffff"}
          isAlphaHidden
          size="small"
          value={value ?? color}
          onChange={handleChange}
          {...props}
          inputRef={ref}
        />
        {color && (
          <IconButton
            size="small"
            disabled={props.disabled}
            onClick={handleReset}
            style={{
              position: "absolute",
              right: "8px",
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            <ClearIcon fontSize="small" />
          </IconButton>
        )}
      </div>
    )
  },
)

ColorInput.displayName = "ColorInput"

export default ColorInput
